<template>
<div>
  <!-- page wrapper start -->
	<div class="pg-wrapper fav-store-list">

    <app-header>
      <div class="title-bar" slot="header-foot">
				<button @click="goBack()" class="button is-flex nav-back">
					<img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back">
				</button>
			  <h1 class="title has-text-black">Favourites</h1>
			</div>
    </app-header>

    <main class="content-wrapper is-relative has-background-white-bis pb0">
			<div class="columns mv0 flex-grow-1">
				<!-- TABS -->
       	<fav-tabs v-if="loaded" tab="store" :productCount="vg_locationFavouriteProducts.length" :storeCount="vg_favouriteLocations.length"></fav-tabs>
				<!-- Search Results Content -->
        <div class="column flex-grow-1 section-search-results" v-if="!loaded">
          <loading></loading>
        </div>
				<div v-else class="column flex-grow-1 section-search-results">
					<section class="columns is-centered">
						<div class="column is-9-widescreen is-8-fullhd is-11-desktop">
							<div class="columns justify-content-between stores-list is-multiline wrapper-675px">
              
                <router-link class="store-item product-black-block is-max-330 column is-12-tablet is-6-desktop" v-bind:key="'store_' + index" v-for="(store, index) in vg_favouriteLocations" :to="{ name: 'StoreProfile', params: { store_slug: store.slug}, query: $route.query }">
                  <div class="store-logo fav-store-logo">
                    <img v-if="getStorefeaturedImage(store.images)" class="store-img" :src="getStorefeaturedImage(store.images)">
                  </div>
                  <div class="store-detail">
                    <div class="store-name fav-store-name-wrap has-text-weight-semibold is-uppercase ">
                      <p class="">{{ store.display_name }}</p>
                      <div class="distance" v-if="store.distance">{{ store.distance }} km</div>
                    </div>
                    <div class="store-address mb5">{{ store.address.formatted_address }}</div>
                    <div class="store-timings is-flex">
                      <span v-if="store.currently_open != undefined" :class="store.currently_open ? 'status has-text-green' : 'status has-text-danger'">{{ store.currently_open ? "Open Now" : "Closed Now" }} •&nbsp;</span>
                      <span class="time">{{ todaysOpeningSchedule(store.hours_of_operation) }}</span>
                    </div>
                  </div>
                </router-link>
							
                <!-- No store available -->
                <div class="column product-tile-wrapper is-6-desktop is-10-widescreen" v-if="vg_favouriteLocations.length < 1">
                  <h3>No Favourites Added.</h3>
                </div>
								
							</div>
						 </div>
					</section>
				</div>
			</div>
		</main>
    <app-footer></app-footer>
	</div>
</div>
</template>

<script>
import LocationApis from '@/Components/Controllers/LocationApis';
import ProductFavouriteApis from '@/Components/Controllers/ProductFavouriteApis';
import Helpers from '@/Components/Helpers/Helpers';
import UserApis from '@/Components/Controllers/UserApis';
import FavTabs from '@/Components/Pages/User/Inc/FavTabs';
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import { find }  from 'lodash';

export default {
  name: 'UserFavouriteStores',
  components: {
    FavTabs,
  },
  data() {
    return {
      loaded: false,
    };
  },

  computed: {
    ...mapGetters({
      vg_favouriteLocations: "favouritestores/list",
      // favouriteProducts: "favouriteproducts/list",
      // businessProfile: "businessprofile/detail", 
      vg_locationFavouriteProducts: "favouriteproducts/locationFavlist", // only return location fav product + escape discontinued
    }),
  },

  async mounted() {
    const self = this;
    let userFavLocations = UserApis.fetchFavLocations();
    let userFavProducts = UserApis.fetchFavProducts();
    Promise.all([userFavLocations, userFavProducts]).then(() => {
      // api goign to save on localstorage
      self.loaded = true;
    }); 
  },

  methods: {
    /**
   * todays store schedule
    */
    todaysOpeningSchedule(locationHours) {
      let today = moment().format('dddd');
      let todaysSchedule = _.find(locationHours, { 'day_name': today });
      if(todaysSchedule){
        return moment(todaysSchedule.open_time, "HH:mm:ss").format("h:mm A") + ' - ' +  moment(todaysSchedule.close_time, "HH:mm:ss").format("h:mm A");
      }
      return ' --- ';
    },
    /**
     * Get store fav image
     */
    getStorefeaturedImage(images) {
     return Helpers.getStoreFeaturedImage(images);
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },
  },
};
</script>
<style scoped>
.store-logo{
  min-width: 80px !important;
}
.store-img{
  max-width: 80px;
}
.fav-store-name-wrap{
  position: relative;
}
.fav-store-name-wrap p {
  width: calc(100% - 80px);
}
.fav-store-name-wrap .distance {
    position: absolute;
    top: 1px;
    right: 0;
}
</style>

